import { render } from "./BeneficialOwner.vue?vue&type=template&id=dbb04fa6&scoped=true"
import script from "./BeneficialOwner.vue?vue&type=script&lang=js"
export * from "./BeneficialOwner.vue?vue&type=script&lang=js"

import "./BeneficialOwner.vue?vue&type=style&index=0&id=dbb04fa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb04fa6"]])

export default __exports__